// extracted by mini-css-extract-plugin
export default {"link":"pageNames_link__LiXQP","main":"pageNames_main__QUoJ3","activeLink":"pageNames_activeLink__SlUkB","mainListings":"pageNames_mainListings__2xUlS"};